import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import { BeatLoader } from 'react-spinners';

interface Props {
  children: ReactNode;
  loading: boolean;
}

export const Loader = ({ children, loading }: Props) => {
  return (
    <div
      className={` w-full overflow-hidden
          ${loading ? 'flex items-center justify-center' : ''}`}
    >
      {loading && (
        <Box className='absolute z-50 flex items-center justify-center'>
          <BeatLoader
            color={'#e20612'}
            loading={true}
            size={25}
            aria-label='Loading Spinner'
            data-testid='loader'
          />
        </Box>
      )}

      {loading && (
        <div className='fixed left-0 top-0 z-40 h-[100vh] w-[100vw] bg-white bg-opacity-70'></div>
      )}

      <div className='w-full z-10'>{children}</div>
    </div>
  );
};
